document.addEventListener("DOMContentLoaded", function () {
  const testimonials = document.querySelectorAll(".testimonial");
  const prevBtn = document.getElementById("prev-btn");
  const nextBtn = document.getElementById("next-btn");

  //Initializing the current index to 0
  let currentIndex = 0;

  // Function that shows specific testimonial by toggling the hidden class
  function showTestimonial(index) {
    testimonials.forEach((testimonial, i) => {
      // If the index is not equal to the current index, the hidden class is added
      testimonial.classList.toggle("hidden", i !== index);
    });
  }

  // Function that navigates to the previous or next testimonial
  function navigate(direction) {
    currentIndex =
      (currentIndex + direction + testimonials.length) % testimonials.length;
    showTestimonial(currentIndex);
  }

  // Event listeners for the previous and next buttons
  prevBtn.addEventListener("click", function () {
    navigate(-1);
  });

  nextBtn.addEventListener("click", function () {
    navigate(1);
  });
});
